import { create } from 'zustand';

interface CouponModalStore {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

export const useCouponModal = create<CouponModalStore>((set) => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false })
}));
